import AdminShell from "components/adminUi/AdminShell";
import ChangeUserPassword from "pages/ChangeUserPassword/ChangeUserPassword";
import { routes } from "pages/routes";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import * as Pages from "./asyncPages";
import RestrictedRoute from "./components/RestrictedRoute";
import SignOut from "./components/SignOut";

export default function AdminRoutes() {
  const location = useLocation();
  return (
    <Routes key={location.pathname}>
      <Route
        path={routes.root.pattern}
        element={<Navigate to={routes.admin.root.path()} replace />}
      />

      {/* Console screens render inside the AdminShell sidebar layout. The
          student-facing catalog surfaces (/library, /course), company
          dashboard/reports and auth utilities stay outside it below. */}
      <Route element={<AdminShell />}>
        <Route
          path={routes.admin.companyDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminCompany} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.companyUserDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminUser} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.companyTeamDetails.pattern}
          element={
            <RestrictedRoute
              Component={Pages.AsyncAdminCompanyTeam}
              permissions="admin"
            />
          }
        />

        <Route
          path={routes.admin.teamDetails.pattern}
          element={
            <RestrictedRoute
              Component={Pages.AsyncAdminCompanyTeam}
              permissions="admin"
            />
          }
        />

        <Route
          path={routes.admin.userDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminUser} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.sessionDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminSession} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.monitoringShift.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminMonitoring} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.questionDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminQuestion} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.schoolDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminSchool} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.settings.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminSettings} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.exerciseDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminExercise} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.tagDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminTag} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.workshopDetails.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminWorkshop} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.pricingModelDetails.pattern}
          element={
            <RestrictedRoute
              Component={Pages.AsyncAdminPricingModel}
              permissions="admin"
            />
          }
        />

        <Route
          path={routes.admin.adaptiveTestingQuestionDetail.pattern}
          element={
            <RestrictedRoute
              Component={Pages.AsyncAdminAdaptiveTestingQuestionDetail}
              permissions="admin"
            />
          }
        />

        <Route
          path={routes.admin.contentFolder.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncContentFolder} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.editContentFile.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncEditContentFile} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.exerciseBuilder.pattern}
          element={
            <RestrictedRoute
              Component={Pages.AsyncAdminBuildExercise}
              permissions="admin"
            />
          }
        />

        {/* Exercises and Tags render directly in the shell (own adminUi
            PageHeader) — routed here so they never fall through to the
            legacy AdminDashboardPage chrome (double header). */}
        <Route
          path={routes.admin.exerciseList.pattern}
          element={
            <RestrictedRoute
              Component={Pages.AsyncAdminExerciseList}
              permissions="admin"
            />
          }
        />

        <Route
          path={routes.admin.tagList.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminTagList} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.root.pattern}
          element={
            <RestrictedRoute Component={Pages.AsyncAdminDashboard} permissions="admin" />
          }
        />
      </Route>

      <Route
        path={routes.admin.companyDashboard.pattern}
        element={<RestrictedRoute Component={Pages.AsyncTeamsPage} permissions="admin" />}
      />

      <Route
        path={routes.companyReportsPage.pattern}
        element={
          <RestrictedRoute
            Component={Pages.AsyncCompanyReportsPage}
            permissions={"admin"}
          />
        }
      />

      <Route
        path={routes.libraryRoot.pattern}
        element={
          <RestrictedRoute Component={Pages.AsyncLibraryRoot} permissions="admin" />
        }
      />

      <Route
        path={routes.libraryObject.pattern}
        element={<RestrictedRoute Component={Pages.AsyncLibrary} permissions="admin" />}
      />

      <Route
        path={routes.courseObject.pattern}
        element={
          <RestrictedRoute Component={Pages.AsyncCoursePage} permissions="admin" />
        }
      />

      <Route
        path={routes.public.signInOAuth.pattern}
        element={
          <RestrictedRoute Component={Pages.AsyncOauthLoading} permissions="admin" />
        }
      />

      <Route
        path={routes.updatePassword.pattern}
        element={<RestrictedRoute Component={ChangeUserPassword} permissions="admin" />}
      />

      <Route path={routes.signOut.pattern} element={<SignOut />} />

      <Route path="*" element={<Navigate to={routes.admin.root.path()} replace />} />
    </Routes>
  );
}
